export const e_meterAlertsConstant={
    METER_ALERTS_SUCCESS:"METER_ALERTS_SUCCESS",
    METER_ALERTS_FAILURE:"METER_ALERTS_FAILURE",
    UPDATE_COUNT:"UPDATE_COUNT"
}